import React from 'react';
import classes from './titledsection.module.scss';

function TitledSection(props) {
  const { title, children, actions } = props;

  return (
    <div className={classes.mainSection}>
      <span className={classes.title}>{title}</span>
      <div className={classes.actions}>{actions}</div>
      <div className={classes.content}>{children}</div>
    </div>
  );
}

export default TitledSection;
